var _excluded = ["ahAnalyticsConfig"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { setHOCDisplayName } from '@domain-group/fe-helper';
import AllhomesAnalytics from './allhomes-analytics';
import { jsx as ___EmotionJSX } from "@emotion/core";
var allhomesAnalyticsEnabled = Component => {
  var AllhomesAnalyticsEnabled = _ref => {
    var _ref$ahAnalyticsConfi = _ref.ahAnalyticsConfig,
      ahAnalyticsConfig = _ref$ahAnalyticsConfi === void 0 ? {} : _ref$ahAnalyticsConfi,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    return ___EmotionJSX(AllhomesAnalytics, ahAnalyticsConfig, ___EmotionJSX(Component, otherProps));
  };
  setHOCDisplayName(AllhomesAnalyticsEnabled, Component, 'allhomesAnalyticsEnabled');
  return AllhomesAnalyticsEnabled;
};
export default allhomesAnalyticsEnabled;